<template>

        <tr class="user">
            <td class="profile" :class="{'inactive':user.active == 0}"><span>{{user.firstname[0]}}</span></td>
            <td class="name">{{user.firstname}} {{user.lastname}}</td>
            <td class="position">{{user.position}}</td>
            <td class="email">{{user.email}}</td>
            <td class="phone">{{user.phone}}</td>
            <td class="roles"><span class="badge badge-light" v-for="role in currentUser.roles">{{role.display_name}}</span></td>
            <td class="actions text center">
                <span class="edit" data-toggle="modal" :data-target="'#modal-'+user.id"><i class="fas fa-edit"></i></span>
                <span class="edit" data-toggle="modal" :data-target="'#modal-password-'+user.id"><i class="fas fa-key"></i></span>
            </td>
            <div class="modal fade" tabindex="-1"  :id="'modal-'+user.id" ref="vuemodal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title">Profila labošana</h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="modalMenu">
                                <span class="modalMenuItem" @click="changeStep(1)" :class="{'active': step === 1}">Profils</span>
                                <span class="modalMenuItem" @click="changeStep(2)" :class="{'active': step === 2}">Lomas</span>
                                <span class="modalMenuItem" @click="changeStep(3)" :class="{'active': step === 3}">Atļaujas</span>
                            </div>
                            <div class="row">
                                <div v-if="step == 1" class="col-12">
                                    <div class="form-group">
                                        <label for="firstname">Vārds</label>
                                        <input v-on:keyup.enter="updateUser" id="firstname" type="text" v-model="firstname" class="form-control" :class="{'is-invalid':errors && ( 'firstname' in errors)}">
                                        <small class="text-danger" v-if="errors && errors.firstname">{{errors.firstname[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="lastname">Uzvārds</label>
                                        <input v-on:keyup.enter="updateUser" id="lastname" type="text" v-model="lastname" class="form-control" :class="{'is-invalid':errors && ( 'lastname' in errors)}">
                                        <small class="text-danger" v-if="errors && errors.lastname">{{errors.lastname[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="email">E-pasts</label>
                                        <input v-on:keyup.enter="updateUser" id="email" type="text" v-model="email" class="form-control" :class="{'is-invalid':errors && ( 'email' in errors)}">
                                        <small class="text-danger" v-if="errors && errors.email">{{errors.email[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="phone">Tālrunis</label>
                                        <input v-on:keyup.enter="updateUser" id="phone" type="text" v-model="phone" class="form-control" :class="{'is-invalid':errors && ( 'phone' in errors)}">
                                        <small class="text-danger" v-if="errors && errors.phone">{{errors.phone[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="position">Amats</label>
                                        <input v-on:keyup.enter="updateUser" id="position" type="text" v-model="position" class="form-control" :class="{'is-invalid':errors && ( 'position' in errors)}">
                                        <small class="text-danger" v-if="errors && errors.position">{{errors.position[0]}}</small>
                                    </div>
                                    <div class="form-group">
                                        <label for="position">Status</label>
                                        <select name="status" id="status" v-model="active" class="form-control">
                                            <option value="1">Aktīvs</option>
                                            <option value="0">Neaktīvs</option>
                                        </select>
                                        <small class="text-muted form-text">Neaktīvajiem lietotājiem, pieslēgšanās sistēmai būs liegta.</small>
                                    </div>
                                </div>
                                <div v-if="step == 2" class="col-12">
                                    <div class="role" :class="{'active': (activeRoles.includes(role.name))}"  v-for="role in allRoles" :key="currentUser.id+'-'+role.id">

                                        <div class="name">{{role.display_name}}</div>
                                        <div class="actions">
                                        <span  @click="removeRole(role.id)" v-if="activeRoles.includes(role.name)" class="switch" :class="{'active':activeRoles.includes(role.name)}">
                                            <span class="circle">
                                                &nbsp;
                                            </span>
                                        </span>
                                            <span @click="addRole(role.id)" v-else class="switch" :class="{'active':activeRoles.includes(role.name)}">
                                            <span class="circle">
                                                &nbsp;
                                            </span>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="step == 3" class="col-12">
                                    <div class="permissionsFilter">

                                        <select name="permissionsFilter" id="permissionsFilter" class="form-control" v-model="selectedPermissionGroup">
                                            <option value="0" selected>Visas atļaujas</option>
                                            <option v-for="group in groups" :value="group.id">{{group.name}}</option>
                                        </select>
                                        <hr>
                                    </div>
                                    <div class="permissions">
                                        <div class="permission" v-for="permission in permissions" v-if="selectedPermissionGroup == 0 || selectedPermissionGroup == permission.permission_group_id" :key="permission.id">
                                            <div class="name">{{permission.display_name}}</div>
                                            <div class="actions">
                                                <div class="roleCol">
                                                    <span class="active" v-tooltip:top="'Atļauja mantota no lomas.'" v-if="activeRolePermissions && activeRolePermissions.includes(permission.name)"><span class="material-icons">fiber_manual_record</span></span>
                                                    <span class="inactive" v-else><span class="material-icons">fiber_manual_record</span></span>
                                                </div>

                                                <span  v-if="activeDirectPermissions && activeDirectPermissions.includes(permission.name)" @click="removeDirectPermission(permission.id)" class="switch" :class="{'active':activeDirectPermissions.includes(permission.name)}">
                                                    <span class="circle">
                                                        &nbsp;
                                                    </span>
                                                </span>
                                                <span v-else @click="addDirectPermission(permission.id)" class="switch">
                                                    <span class="circle">
                                                        &nbsp;
                                                    </span>
                                                </span>


                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <input type="button" class="btn btn-primary" value="Saglabāt" v-if="loading == false" @click="updateUser()">
                            <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" tabindex="-1"  :id="'modal-password-'+user.id" ref="vuemodalpassword">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h5 class="modal-title">Paroles attiestatīšana</h5>
                            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="modalMenu">

                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group text-center">
                                        <input type="button" v-if="loading == false" class="btn btn-primary" value="Nosūtīt paroles attiestatīšanas e-pastu" @click="sendPasswordReset(user.id)">
                                        <button type="button" v-else class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                                        <hr>
                                        <input type="button" v-if="loading == false" class="btn btn-primary" value="Nosūtīt profila izveides e-pastu" @click="sendRegisterEmail(user.id)">
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </tr>



</template>

<script>
    export default {
        props:['user','roles','permissions','groups'],
        created()
        {
          this.firstname = this.$props.user.firstname;
          this.lastname = this.$props.user.lastname;
          this.email = this.$props.user.email;
          this.phone = this.$props.user.phone;
          this.position = this.$props.user.position;
          this.id = this.$props.user.id;
          this.active = this.$props.user.active;
          this.allRoles = this.$props.roles;
          this.currentUser = this.$props.user;
        },
        data() {
            return {
                selectedPermissionGroup:0,
                loading: false,
                errors: null,
                firstname: null,
                lastname: null,
                phone: null,
                email: null,
                position: null,
                id:null,
                allRoles:[],
                currentUser:null,
                step:1,
                active:null
            }
        },

            computed:{
                activeDirectPermissions: function()
                {
                    let direct_permissions = [];
                    this.currentUser.permissions.forEach(permission =>{
                       direct_permissions.push(permission.name)
                    });
                    return direct_permissions;
                },
                activeRolePermissions: function()
                {
                  var permissions = [];
                  this.currentUser.roles.forEach(role =>{
                      if(role.permissions != null) {
                          role.permissions.forEach(permission => {
                              permissions.push(permission.name)
                          })
                      }
                  });
                  return permissions;
                },
                activeRoles: function(currentUser)
                {
                    var roles = [];
                    this.currentUser.roles.forEach(role =>
                    {
                        roles.push(role.name);
                    });

                    return roles;

                }
            },
            methods: {
                sendPasswordReset(userID)
                {
                    var that = this;
                    that.loading = true;
                    axios.post('/dashboard/api/generate/password/reset',{
                        userID:userID
                    }).then(response =>{
                        that.loading = false;
                        that.$toast.open(response.data.message);
                        $(that.$refs.vuemodalpassword).modal('hide');
                    });
                },
                sendRegisterEmail(userID)
                {
                    var that = this;
                    that.loading = true;
                    axios.post('/dashboard/api/generate/profile/reset',{
                        userID:userID
                    }).then(response =>{
                        that.loading = false;
                        that.$toast.open(response.data.message);
                        $(that.$refs.vuemodalpassword).modal('hide');
                    });
                },

                changeStep(step)
                {
                  this.step = step;
                },

                addDirectPermission(id)
                {
                    var that = this;
                    axios.post('dashboard/user/'+that.id+'/addpermission/'+id).then(response =>{
                        that.currentUser = response.data.user;
                        that.$toast.open(response.data.message);
                    });
                },
                removeDirectPermission(id)
                {
                    var that = this;
                    axios.post('dashboard/user/'+that.id+'/removepermission/'+id).then(response =>{
                        that.currentUser = response.data.user;
                        that.$toast.open(response.data.message);
                    });
                },
                addRole(id)
                {
                    var that = this;
                    axios.post('/dashboard/user/'+that.id+'/addrole/'+id).then(response =>
                    {
                        that.currentUser = response.data.user;
                        that.$toast.open(response.data.message);
                    })
                },
                removeRole(id)
                {
                    var that = this;
                    axios.post('/dashboard/user/'+that.id+'/removerole/'+id).then(response =>
                    {
                        that.currentUser = response.data.user;
                        that.$toast.open(response.data.message);
                    })
                },
                updateUser()
                {
                    var that = this;
                    this.loading = true;
                    axios.post('/dashboard/api/users/'+that.id,{
                        firstname: this.firstname,
                        lastname: this.lastname,
                        email: this.email,
                        phone: this.phone,
                        position: this.position,
                        active: this.active

                    }).then(response =>{
                        that.loading = false;
                        if (response.data.status == 'ok')
                        {
                             EventBus.$emit('user_updated');
                            $(that.$refs.vuemodal).modal('hide');

                        }

                        if (response.data.status == 'error')
                        {
                            that.step = 1;
                            that.errors = response.data.errors;
                        }



                    })
                }
            }

    }
</script>

<style lang="scss" scoped>

    @use "sass:color";
    @import '../../sass/variables';
    .userWrapper{
        display:inline-block;
        border-bottom:solid 1px #eee;
        min-width:100%;
        &:hover{
            background-color:#eee;
        }
    }
    .switch{
        width:45px;
        height:25px;
        background:#eee;
        border-radius:15px;
        position:relative;
        .circle{
            position:absolute;
            top:2.5px;
            left:2.5px;
            height:20px;
            width:20px;
            background:#fff;
            border-radius:100%;
            transition:all .2s ease-in-out;
        }
        &.active{
            .circle{
                transform:translateX(17.5px);
                background:$blue;
            }
            &.green{
                .circle{
                    background:$green;
                }
            }
        }
    }
    .role{
        padding:10px;
        display:flex;
        border-bottom: 1px #eee solid;
        .name{
            font-weight:bold;
            display:flex;
            align-items: center;
        }
        .actions{
            display:flex;
            align-items: center;
            cursor: pointer;

            .active, .inactive{
                cursor: pointer;
                text-align: center;
                padding:10px;

            }
            .active{
                color:$green;
            }
            .inactive{
                color:#aaa;
            }
            margin-left:auto;
        }
    }
    .permissions{
        .permission{
            padding:10px;
            display:flex;
            border-bottom: 1px #eee solid;
            .name{
                font-weight:bold;
                display:flex;
                align-items: center;
            }
            .actions{
                display:flex;
                align-items: center;
                cursor: pointer;
                .roleCol{
                    cursor: pointer;
                    text-align: center;
                    padding:10px;
                    display:flex;
                    align-items: center;
                    .active{
                        color:$blue;
                        display:flex;
                        align-items: center;
                    }
                    .inactive{
                        color:#aaa;
                        display:flex;
                        align-items: center;
                    }
                }
                margin-left:auto;
            }
        }
    }



.user{
    /*display:flex;*/
    padding:10px;
    align-items: center;
    cursor:pointer;
    transition:all .2s ease-in-out;
    td{
        vertical-align: middle;
    }

    .profile{


        &.inactive>span{

            background:#eee;
        }
        flex-shrink:0;
        &>span{
            display:block;

            color:#fff;
            font-size:24px;
            font-weight:bold;
            line-height:1;
            width:40px;
            height:40px;
            display:flex;
            align-items:center;
            justify-content: center;
            border-radius:100%;
            background:#f1c40f;

        }

    }
    .name{
        min-width:150px;
        width:15%;
        padding:0 10px;
        flex-shrink:0;
    }
    .position{
        min-width:200px;
        width:15%;
        padding:0 10px;
        flex-shrink:0;
        font-size:.9em;
    }
    .email{
        min-width:200px;
        width:15%;
        padding:0 10px;
        flex-shrink:0;
        font-size:.9em;
    }
    .phone{
        min-width:150px;
        width:15%;
        padding:0 10px;
        flex-shrink:0;
        font-size:.9em;
    }
    .roles{
        min-width:150px;
        width:15%;
        padding:0 10px;
        flex-shrink:0;
        font-size:.9em;
    }
    .actions{
        margin-left:auto;
        min-width:100px;
        width:15%;
        padding:0 10px;
        flex-shrink:1;
        text-align: center;
    }
}
</style>
